import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, watch } from 'vue';
	import { useStore } from 'vuex';
	import { IStoreState, IVehicle } from '@/types';
	import { tilesPerPage } from '@/config';

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const showButton = ref(true);

	const store = useStore<IStoreState>();
	const index = computed((): number => store.state.vehiclesIndex);
	const totalVehicles = computed((): number => store.state.totalVehicles);
	const vehicles = computed((): Array<IVehicle> => store.state.vehicles);

	const handleLoadClick = ($event: Event) => {
		$event.preventDefault();
		store.commit('setVehiclesIndex', index.value + tilesPerPage);
		store.dispatch('updateVehicles', { amend: true });
	};

	watch(totalVehicles, () => {
		showButton.value = totalVehicles.value != vehicles.value.length;
	});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("a", {
    class: "button-solid",
    "aria-controls": "uv-tile-list",
    role: "button",
    onClick: handleLoadClick
  }, "Load More", 512)), [
    [_vShow, showButton.value]
  ])
}
}

})